import React from "react";
import { t } from "i18next";
import { Checkbox } from "@fluentui/react";

/**
 * "Auto-expand series with cine clips" row of the preferences page (all roles).
 * On: in the study viewer's series panel, a series that contains multi-frame
 * cine clips opens expanded into per-instance tiles. Off: series stay collapsed
 * (they can still be expanded by hand).
 */
const AutoExpandCineSeriesPreference = ({ checked, onChange, themeName }) => (
  <div className="ms-Grid-row single-line-form-field" data-testid="auto-expand-cine-series-preference">
    <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
      <div style={{ display: "flex", alignItems: "center" }}>
        <p className="single-line-form-field-key" style={{ width: "250px" }}>
          {t("account-and-settings.auto-expand-cine-series", "Auto-expand series with cine clips")}
        </p>
        <div className="checkbox-container" style={{ width: "24px" }}>
          <Checkbox
            ariaLabel="Auto-expand series with cine clips"
            checked={!!checked}
            onChange={(_, value) => onChange(!!value)}
          />
        </div>
      </div>
      <p style={{ fontSize: "13px", color: themeName === "light" ? "#808080" : "#bebebe" }}>
        In the viewer's series panel, open series that contain multi-frame clips as
        individual image tiles. Other series are not affected.
      </p>
    </div>
  </div>
);

export default AutoExpandCineSeriesPreference;
